import {Routes} from '@angular/router';
import {Login} from "@pages/auth/login/login";
import {RedirectCallback} from "@pages/auth/redirect-callback/redirect-callback";
import {NoPermission} from "@pages/auth/no-permission/no-permission";
import {Auth} from '@components/layout/auth/auth';
import {authGuard} from "@core/guards/auth-guard";
import {LoginConcessionariasComponent} from '@pages/auth/login-concessionarias/login-concessionarias.component';
import {IconBoldProfileUser} from '@components/icons/icon-bold-profile-user/icon-bold-profile-user';
import {IconBoldBuilding4Component} from '@components/icons/icon-bold-building-4/icon-bold-building-4.component';
import {IconBoldLockCircle} from '@components/icons/icon-bold-lock-circle/icon-bold-lock-circle';
import {IconBoldFlag} from '@components/icons/icon-bold-flag/icon-bold-flag';
import {readonlyOcorrenciaGuard} from '@core/guards/readonly-ocorrencia-guard';
import {IconBoldEdit} from '@components/icons/icon-bold-edit/icon-bold-edit';
import {IconBoldEyeComponent} from '@components/icons/icon-bold-eye/icon-bold-eye.component';
import {IconBoldAddSquare} from '@components/icons/icon-bold-add-square/icon-bold-add-square';
import {IconBoldUserTag} from '@components/icons/icon-bold-user-tag/icon-bold-user-tag';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@components/layout/main/main').then(m => m.Main),
    canActivate: [authGuard],
    data: {
      funcionalidade: 'free-page',
    },
    children: [
      {
        path: 'controle-usuarios',
        data: {
          breadcrumb: 'Controle de Usuários',
          icon: IconBoldUserTag,
          navigable: false,
        },
        children: [
          {
            path: 'usuarios-internos',
            loadComponent: () => import('@pages/controle-usuarios/usuarios-internos/usuarios-internos').then(m => m.UsuariosInternos),
            canActivate: [authGuard],
            data: {
              funcionalidade: 'controle_usuarios_internos',
              acao: 'visualizar',
              breadcrumb: 'Usuários Internos',
              icon: IconBoldProfileUser
            }
          },
          {
            path: 'usuarios-externos',
            loadComponent: () => import('@pages/controle-usuarios/usuarios-externos/usuarios-externos').then(m => m.UsuariosExternos),
            canActivate: [authGuard],
            data: {
              funcionalidade: 'controle_usuarios_externos',
              acao: 'visualizar',
              breadcrumb: 'Usuários Externos',
              icon: IconBoldProfileUser
            }
          },
          {
            path: 'grupos-usuarios',
            loadComponent: () => import('@pages/controle-usuarios/grupos-usuarios/grupos-usuarios').then(m => m.GruposUsuarios),
            canActivate: [authGuard],
            data: {
              funcionalidade: 'grupo_usuarios',
              acao: 'visualizar',
              breadcrumb: 'Grupo de Usuários',
              icon: IconBoldProfileUser
            }
          },
          {
            path: 'usuarios-empresas',
            loadComponent: () => import('@pages/controle-usuarios/empresas/empresas').then(m => m.Empresas),
            canActivate: [authGuard],
            data: {
              funcionalidade: 'empresas',
              acao: 'visualizar',
              breadcrumb: 'Empresas',
              icon: IconBoldBuilding4Component
            }
          }
        ]
      },
      {
        path: 'controle-perfil',
        loadComponent: () => import('@pages/controle-perfil/controle-perfil').then(m => m.ControlePerfil),
        canActivate: [authGuard],
        data: {
          funcionalidade: 'perfil',
          acao: 'visualizar',
          breadcrumb: 'Controle de Perfis',
          icon: IconBoldLockCircle
        }
      },
      {
        path: 'ocorrencias',
        loadComponent: () => import('@pages/ocorrencias/ocorrencias').then(m => m.Ocorrencias),
        canActivate: [authGuard],
        data: {
          funcionalidade: ['ocorrencias_internas', "ocorrencias_externas"],
          acao: 'visualizar',
          breadcrumb: 'Ocorrências',
          icon: IconBoldFlag
        },
        children: [
          {
            path: 'adicionar-ocorrencia',
            loadComponent: () => import('@pages/ocorrencias/add-edit-ocorrencia/add-edit-ocorrencia').then(m => m.AddEditOcorrencia),
            data: {
              breadcrumb: 'Adicionar Ocorrência',
              title: 'Ocorrências',
              icon: IconBoldAddSquare,
            }
          },
          {
            path: 'editar-ocorrencia/:id',
            loadComponent: () => import('@pages/ocorrencias/add-edit-ocorrencia/add-edit-ocorrencia').then(m => m.AddEditOcorrencia),
            canActivate: [readonlyOcorrenciaGuard],
            data: {
              breadcrumb: 'Editar Ocorrência',
              title: 'Ocorrências',
              icon: IconBoldEdit
            }
          },
          {
            path: 'visualizar-ocorrencia/:id',
            loadComponent: () => import('@pages/ocorrencias/add-edit-ocorrencia/add-edit-ocorrencia').then(m => m.AddEditOcorrencia),
            data: {
              breadcrumb: 'Visualizar Ocorrência',
              title: 'Ocorrências',
              icon: IconBoldEyeComponent
            }
          }
        ]
      }
    ]
  },
  {
    path: 'auth',
    component: Auth,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        component: Login,
      },
      {
        path: 'login-concessionarias',
        component: LoginConcessionariasComponent,
      },
      {
        path: 'redirect-callback',
        component: RedirectCallback,
      },
      {
        path: 'no-permission',
        component: NoPermission,
      },
    ],
  },
  {path: '**', redirectTo: '', pathMatch: 'full'},

];
